module.exports = __webpack_public_path__ + "img/check-unavailable.602882ee.svg";